import { render } from "./UserBar.vue?vue&type=template&id=dd3285bc&lang=pug"
import script from "./UserBar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__